import Vue from "vue";
import App from "./app.vue";
import router from "./router";
import store from "./store";

//
// Urlcheckr framework
import AddUrls from "./components/url/add-urls.vue";
Vue.component("uc-add-urls", AddUrls);

import AddImport from "./components/url/add-import.vue";
Vue.component("uc-add-import", AddImport);

import AddManual from "./components/url/add-manual.vue";
Vue.component("uc-add-manual", AddManual);

import Alert from "./components/alert/alert.vue";
Vue.component("uc-alert", Alert);

import Deco from "./components/deco/deco.vue";
Vue.component("uc-deco", Deco);

import EditableUrl from "./components/url/editable-url.vue";
Vue.component("uc-editable-url", EditableUrl);

import InvalidBadge from "./components/badge/badge--invalid.vue";
Vue.component("uc-invalid-badge", InvalidBadge);

import Pane from "./components/results/pane.vue";
Vue.component("uc-pane", Pane);

import PremiumBadge from "./components/plans/premium-badge.vue";
Vue.component("uc-premium-badge", PremiumBadge);

import ReasonPhraseBadge from "./components/badge/reason-phrase.vue";
Vue.component("uc-reason-phrase-badge", ReasonPhraseBadge);

import ResponseTimeBadge from "./components/badge/response-time.vue";
Vue.component("uc-response-time-badge", ResponseTimeBadge);

import SslBadge from "./components/badge/ssl.vue";
Vue.component("uc-ssl-badge", SslBadge);

import StatusBadge from "./components/badge/status.vue";
Vue.component("uc-status-badge", StatusBadge);

import SubscriptionPlans from "./components/subscription/plans.vue";
Vue.component("uc-subscription-plans", SubscriptionPlans);

import Title from "./components/content/title.vue";
Vue.component("uc-title", Title);

import UnreachableBadge from "./components/badge/unreachable.vue";
Vue.component("uc-unreachable-badge", UnreachableBadge);

//
// Element UI
import "../src/theme/style.scss";
import ElementUI from "element-ui";
// @ts-ignore
import locale from "element-ui/lib/locale/lang/en";
Vue.use(ElementUI, { locale });

//
// RecycleScroller
// @ts-ignore
import { RecycleScroller } from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
Vue.component("RecycleScroller", RecycleScroller);

//
// Gravatar
// @ts-ignore
import Gravatar from "vue-gravatar";
Vue.component("v-gravatar", Gravatar);

//
// Moment
// eslint-disable-next-line @typescript-eslint/no-var-requires
Vue.use(require("vue-moment"));

//
// Currency
import VueCurrencyFilter from "vue-currency-filter";
Vue.use(VueCurrencyFilter, {
  symbol: "€",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true,
});

//
// Google Tagmanager
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "UA-60138521-3" },
});

//
// Vue
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

//
// Sentry
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
function sentryInit() {
  Sentry.init({
    dsn: "https://ce7ba2b9505848c589b663ede32b1aa8@sentry.io/1780368",
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });
}

process.env.NODE_ENV === "production" ? sentryInit() : null;
